import axios from '../lib/axios';
import { BusinessEntity, CreateBusinessEntityRequest, UpdateBusinessEntityRequest } from '../types/businessEntity';

export const businessEntitiesApi = {
  async list(): Promise<BusinessEntity[]> {
    const response = await axios.get('/business-entities');
    return response.data;
  },

  async getById(entityId: string): Promise<BusinessEntity> {
    const response = await axios.get(`/business-entities/${entityId}`);
    return response.data;
  },

  async create(data: CreateBusinessEntityRequest): Promise<BusinessEntity> {
    const response = await axios.post('/business-entities', data);
    return response.data;
  },

  async update(entityId: string, data: UpdateBusinessEntityRequest): Promise<BusinessEntity> {
    const response = await axios.put(`/business-entities/${entityId}`, data);
    return response.data;
  },

  async delete(entityId: string): Promise<void> {
    await axios.delete(`/business-entities/${entityId}`);
  },
};
